import { jsx as _jsx } from "react/jsx-runtime";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { categoriesStore } from "../../../stores/useCategoriesStore";
import { postsStore } from "../../../stores/posts/postsStore";
import { textFieldStyle } from "../../../assets/styles/styles";
export const CategorySelector = ({ value, onChange }) => {
    const options = categoriesStore.useCategories();
    return (_jsx(Autocomplete, { sx: {
            maxWidth: 500,
            ...textFieldStyle
        }, multiple: true, limitTags: 3, filterSelectedOptions: true, value: value, options: options, getOptionLabel: (option) => `${option.name} (${option.shortName})`, onChange: onChange, renderInput: (params) => (_jsx(TextField, { ...params, variant: "standard", label: "Select Category", placeholder: "Categories" }, void 0)) }, void 0));
};
export default function SelectCategory() {
    const value = postsStore.useNewPostCategories();
    return (_jsx(CategorySelector, { value: value, onChange: (_event, newValue) => {
            postsStore.setNewPost({ ...postsStore.getNewPost(), categories: newValue });
        } }, void 0));
}
//# sourceMappingURL=SelectCategory.js.map